// extracted by mini-css-extract-plugin
export default {"score":"Edit_score__Ffx2e","label":"Edit_label__sDs--","actionContainer":"Edit_actionContainer__mmyX8"};